import React, { useContext, useState, useEffect } from 'react'
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Layout from './Components/Layout';
import Home from './Pages/Home';
import Srp from './Pages/Srp';
import LeaseSpecials from './Pages/LeaseSpecials';
import AboutStaff from './Pages/AboutStaff';
import Contact from './Pages/Contact';
import RoadsideAssistance from './Pages/RoadsideAssistance';
import LeaseReturn from './Pages/LeaseReturn';
import Service from './Pages/Service';
import OrderParts from './Pages/OrderParts';
import ConsignmentAgreement from './Pages/ConsignmentAgreement';
import Vdp from './Pages/Vdp';
import VdpNew from './Pages/VdpNew';
import SellOrTrade from './Pages/SellOrTrade';
import FinanceCalculator from './Pages/FinanceCalculator';
import Blog from './Pages/Blog';
import Boutique from './Pages/Boutique';
import AdminLayout from './Components/Admin/AdminLayout';
import Dashboard from './Components/Admin/Dashboard';
import FeaturedVehicles from './Components/Admin/FeaturedVehicles';
import ModelSpecific from './Pages/ModelSpecific';
import { UserContext } from './Components/Context/UserContext';
import Login from './Components/Admin/Login';
import PrivacyPolicy from './Components/Common/PrivacyPolicy';
import Sitemap from './Pages/Sitemap';
import ProductDetails from './Pages/ProductDetails';
import ThankYou from './Components/Common/ThankYou';
import ServiceSpecials from './Components/Admin/ServiceSpecials';
import TermsAndConditions from './Components/Common/TermsAndConditions';

const PrivateRoute = ({ user }) => {
    return user && user.username && user.username !== "publicuser" ? (
        <Outlet />
    ) : (
        <Navigate to="/login" replace />
    );
};

const PublicRoute = ({ user, children }) => {
    return user && user.username && user.username !== "publicuser" ? (
        <Navigate to="/admin/dashboard" replace />
    ) : (
        children
    );
};

const AppRoutes = () => {
  const {user, loggedInCheck} = useContext(UserContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      const checkLoginStatus = async () => {
          if (window.location.pathname.startsWith("/admin") || window.location.pathname === "/login") {
              await loggedInCheck();
          }
          setLoading(false);
      };
      checkLoginStatus();
  }, []);
  if (loading) {
      return <div>Loading...</div>;
  }

  return (
    <Routes>
      {/* <Route path="/login" element={<Login />} /> */}
      <Route
        path="/*"
        element={
          <Layout>
            <Routes>
              <Route index element={<Home />} />
              <Route path='/inventory' element={<Srp />} />
              <Route path='/inventory/new' element={<Srp typeFilter={["new","recently sold"]}/>} />
              <Route path='/new-inventory' element={<Srp typeFilter={["new","recently sold"]}/>} />
              <Route path='/inventory/used' element={<Srp typeFilter={["used","recently sold"]}/>} />
              <Route path='/inventory/recently-sold' element={<Srp typeFilter={"recently sold"}/>} />
              <Route path='/used-inventory' element={<Srp typeFilter={["used","recently sold"]}/>} />
              <Route path='/inventory/certified-used' element={<Srp typeFilter={["used","recently sold"]} certified={true}/>} />
              <Route path='/certified-pre-owned' element={<Srp typeFilter={["used","recently sold"]} certified={true}/>} />
              <Route path='/vehicle-details/*' element={<Vdp />} />
              <Route path='/vdp-new' element={<VdpNew />} />
              <Route path='/lease-specials' element={<LeaseSpecials />} />
              <Route path='/about-staff' element={<AboutStaff />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/roadside-assistance' element={<RoadsideAssistance />} /> 
              <Route path='/lease-return' element={<LeaseReturn />} /> 
              <Route path='/service' element={<Service />} /> 
              <Route path='/order-parts' element={<OrderParts />} /> 
              <Route path='/consignment-agreement' element={<ConsignmentAgreement />} /> 
              <Route path='/sell-or-trade' element={<SellOrTrade />} /> 
              <Route path='/finance-calculator' element={<FinanceCalculator />} /> 
              <Route path='/blog' element={<Blog />} /> 
              <Route path='/shopping' element={<Boutique />} /> 
              <Route path='/product-details' element={<ProductDetails />} /> 
              <Route path='/gts' element={<ModelSpecific />} /> 
              <Route path='/privacy-policy' element={<PrivacyPolicy />} /> 
              <Route path='/terms-and-conditions' element={<TermsAndConditions />} /> 
              <Route path='/sitemap' element={<Sitemap />} /> 
              <Route path='/thank-you' element={<ThankYou />} /> 
            </Routes>
          </Layout>
        }
      />
        <Route
            path="/login"
            element={
                <PublicRoute user={user}>
                    <Login />
                </PublicRoute>
            }
        />
        {/* Private Routes */}
        {/* {checkedLogin &&  */}
        <Route element={<PrivateRoute user={user} />}>
            <Route element={<AdminLayout />}>
                <Route path="/admin/dashboard" element={<Dashboard />} />
                <Route path="/admin/featured-vehicles" element={<FeaturedVehicles />} />
                <Route path="admin/service-specials" element={<ServiceSpecials />} />
                
                {/* Replace URL's */}
                <Route path="/admin/*" element={<Navigate to="/admin/dashboard" replace />} />
                <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            </Route>
        </Route>
        {/* // } */}
        {/* {!checkedLogin && <>
            <Route path="/admin/manage-vehicles" element={<Login />} />
        </>} */}
        <Route path="*" element={<Navigate to="/inventory" replace />} />
    </Routes>
  )
}

export default AppRoutes